namespace Matrix.Rebalancer {
    export interface ModellingViewColumnRow {
        ColumnSetCode?: string;
        ChildView?: boolean;
        FieldName?: string;
        SortOrder?: number;
        Header?: string;
        Expression?: string;
        DataType?: string;
        FormatString?: string;
        Alignment?: string;
        GroupIndex?: number;
        SortFieldName?: string;
        GroupSummary?: string;
        GroupSummaryFormat?: string;
        TotalSummary?: string;
        TotalSummaryFormat?: string;
        ReadOnly?: boolean;
        Visible?: boolean;
        Frozen?: boolean;
        IsDetail?: boolean;
        ActionTemplate?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        ColumnSetName?: string;
        ColumnSetRowId?: number;
    }

    export namespace ModellingViewColumnRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'ColumnSetCode';
        export const localTextPrefix = 'Rebalancer.ModellingViewColumn';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            ColumnSetCode = "ColumnSetCode",
            ChildView = "ChildView",
            FieldName = "FieldName",
            SortOrder = "SortOrder",
            Header = "Header",
            Expression = "Expression",
            DataType = "DataType",
            FormatString = "FormatString",
            Alignment = "Alignment",
            GroupIndex = "GroupIndex",
            SortFieldName = "SortFieldName",
            GroupSummary = "GroupSummary",
            GroupSummaryFormat = "GroupSummaryFormat",
            TotalSummary = "TotalSummary",
            TotalSummaryFormat = "TotalSummaryFormat",
            ReadOnly = "ReadOnly",
            Visible = "Visible",
            Frozen = "Frozen",
            IsDetail = "IsDetail",
            ActionTemplate = "ActionTemplate",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            ColumnSetName = "ColumnSetName",
            ColumnSetRowId = "ColumnSetRowId"
        }
    }
}
